module.exports = __webpack_public_path__ + "img/ufo.79383cdf.png";